<template>
  <div class="grid-view">
    <div class="main-content accounting-document-type">
      <div class="section operations">
        <div class="filters">
          <span v-if="!locked">
            <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
            <el-button type="primary" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
          </span>
          <span v-else>
            <el-button :disabled="!cellSelected" type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="primary" @click="refreshHandler">{{ $t('common.btn.refresh') }}</el-button>
          </span>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height: 500px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import * as accountingDocumentTypeApi from '@/api/financeManage/accountingDocumentType'

export default {
  name: 'VoucherTypeMapping',
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      cellSelected: false, // 是否选中行
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        onRowClicked: () => { this.cellSelected = true }
      },
      rowData: [],
      locked: true
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherType'),
          field: 'name',
          width: 100,
          editable: !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params)
        }, {
          headerName: this.$t('CargoMsg.Cargo_DescriptionOfVoucherType'),
          field: 'remarks',
          width: 180,
          editable: !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params)
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoucherLetter'),
          field: 'prefix',
          width: 100,
          editable: !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => this.onCellChange(params)
        }
      ]
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    editHandler() {
      if (this.rowData && this.rowData.length > 0) {
        this.locked = false
      }
    },
    saveHandler() {
      const saveList = []
      for (const row of this.rowData) {
        if (['add', 'edit'].includes(row.waitDealStatus)) {
          saveList.push(row)
        }
      }
      if (saveList.length) {
        // 校验
        for (const row of saveList) {
          if (!row.name) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterVoucherType'))
            return
          } else if (!row.prefix) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterVoucherLetter'))
            return
          }
        }
        // 保存
        const loading = getLoading()
        accountingDocumentTypeApi.save(saveList).then(resp => {
          this.saveSuccess(resp)
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        }).finally(() => loading.close())
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataModifiedNoNeedToSave'))
      }
      this.locked = true
    },
    cancelHandler() {
      this.locked = true
      this.loadList()
    },
    loadList() {
      const loading = getLoading()
      const params = {}
      params.accountingSetKey = this.accountSet.uuid
      accountingDocumentTypeApi.query(params).then(resp => {
        this.rowData = resp.data.list
        this.gridOptions.api.refreshCells({ force: true })
      }).finally(() => loading.close())
      this.gridOptions.api.clearFocusedCell()
      this.cellSelected = false
    },
    refreshHandler() {
      this.loadList()
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitDealStatus = 'edit'
      }
    },
    saveSuccess(resp) {
      // 返回的列表中可能同时含有编辑的和新增的数据
      const list = resp.data
      if (!list || list.length === 0) return
      // 1 遍历rowData列表能匹配到uuid的数据（编辑的数据），更新数据
      for (let i = 0; i < this.rowData.length; i++) {
        const row = this.rowData[i]
        if (row.uuid) {
          const index = list.findIndex(params => params.uuid === row.uuid)
          if (index > -1) {
            Object.assign(row, list[index])
            list.splice(index, 1)
          }
          row.waitDealStatus = ''
        }
      }
      // 2 遍历rowData列表中没有uuid的数据 删除该数据
      for (let i = this.rowData.length - 1; i >= 0; i--) {
        if (!this.rowData[i].uuid) {
          this.rowData.splice(i, 1)
        }
      }
      // 3 添加列表里没有匹配uuid的数据（新增的数据）到列表
      this.rowData.push(...list)
      this.gridOptions.api.refreshCells({ force: true })
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
    }
  }
}
</script>

<style scoped>

</style>
